const services = {};

export function registerService(name, service) {
  services[name] = service;
}

export default services;
